module.exports = __webpack_public_path__ + "img/logo.91a43118.png";